import React, { useContext } from "react";
import PageBanner from "../components/PageBanner";
import { LanguageContext } from "../LanguageContext"; // Import the context

const Safety = () => {
  const { language } = useContext(LanguageContext); // Use the context
  // Text content for English and Arabic
  const text = {
    en: {
      safetyBasics: "Safety Basics",
      yourSafetyIsOurPriorityPleaseFollowTheseEssentialGuideline:
        "Your safety is our priority. Please follow these essential guidelines to ensure a secure and enjoyable experience within the OneFurever community.",
      reviewProfilesAndReferencesCarefully:
        "Review Profiles and References Carefully",
      beforeParticipatingInaPlaytimeOrEventTakeTheTime:
        "Before participating in a playtime or event, take the time to thoroughly review member profiles. Read what members say about themselves and check references from other members. Trust your judgment, if something feels off, keep looking.",
      trustYourInstincts: "Trust Your Instincts",
      ifaSituationPersonOrProfileSeemsUnsafeListenToYourGut:
        "If a situation, person, or profile seems unsafe, listen to your gut. Your well-being comes first. Set clear boundaries, and don’t hesitate to remove yourself from any situation that makes you uncomfortable. If you prefer, consider meeting members in public places or in groups.",
      stayInformedAboutLocalCultureAndSafetyPractices:
        "Stay Informed About Local Culture and Safety Practices",
      ifYouAreTravelingTakeTheTimeToResearchCulturalNorms:
        "If you’re traveling, take the time to research general safety recommendations for the area. Awareness is key to ensuring a smooth and secure experience.",
      communicateThroughOneFurever: "Communicate Through OneFurever",
      ForYourSafetyKeepAllCommunicationWithinTheOneFureverMobileApp:
        "For your safety, keep all communication within the OneFurever mobile app. Avoid sharing personal contact details such as phone numbers or email addresses with new acquaintances. Keeping conversations on the platform allows our App control team to monitor interactions and respond quickly to any issues.",
      KnowYourLimits: "Know Your Limits",
      enjoyYourselfButAlwaysPrioritizeYourSafety:
        "Enjoy yourself, but always prioritize your safety and well-being. Avoid situations where you may lose control, and be mindful of your surroundings.",
      leaveHonestReferences: "Leave Honest References",
      useTheReferenceSystemToShareYourExperiencesWithOther:
        "Use the Reference System to share your experiences with other OneFurever members. Providing honest and clear feedback helps the community make informed decisions and fosters a safer environment.",
      reportSafetyConcerns: "Report Safety Concerns",
      ifYouEncounterAnySafetyIssuesReportThemToOurTrust:
        "If you encounter any safety issues, report them to our team. Your reports help us maintain the integrity of OneFurever and protect future members.",
      acceptance: "By adhering to these guidelines, we can create a positive and enriching community experience for all. Thank you for being a valued member of OneFurever!"
    },
    ar: {
      safetyBasics: "أساسيات السلامة",
      yourSafetyIsOurPriorityPleaseFollowTheseEssentialGuideline:
        "سلامتك هي أولويتنا. يرجى اتباع هذه الإرشادات الأساسية لضمان تجربة آمنة وممتعة داخل مجتمع \"وان فوريفر\"",
      reviewProfilesAndReferencesCarefully:
        "راجع الملفات الشخصية والمراجع بعناية",
      beforeParticipatingInaPlaytimeOrEventTakeTheTime:
        "قبل المشاركة في أي لقاء أو فعالية، خذ وقتك لمراجعة الملفات الشخصية للأعضاء بدقة. اقرأ ما يكتبونه عن أنفسهم وتحقق من المراجع التي قدمها أعضاء آخرون. ثق في حدسك، إذا شعرت بأن هناك شيئًا غير مريح، استمر في البحث.",
      trustYourInstincts: "ثق بحدسك",
      ifaSituationPersonOrProfileSeemsUnsafeListenToYourGut:
        "إذا بدا لك أن موقفًا أو شخصًا أو ملفًا شخصيًا غير آمن، استمع إلى إحساسك الداخلي. سلامتك تأتي أولًا. ضع حدودًا واضحة، ولا تتردد في الابتعاد عن أي موقف يجعلك تشعر بعدم الارتياح. فكر في مقابلة الأعضاء في أماكن عامة أو ضمن مجموعات إذا كنت تفضل ذلك.",
      stayInformedAboutLocalCultureAndSafetyPractices:
        "ابقَ على اطلاع حول الثقافة المحلية وممارسات السلامة",
      ifYouAreTravelingTakeTheTimeToResearchCulturalNorms:
        "إذا كنت مسافرًا، فاحرص على البحث عن العادات الثقافية المحلية والتوصيات العامة للسلامة في المنطقة. الوعي هو مفتاح ضمان تجربة سلسة وآمنة.",
      communicateThroughOneFurever: "تواصل عبر \"وان فوريفر\"",
      ForYourSafetyKeepAllCommunicationWithinTheOneFureverMobileApp:
        "لضمان سلامتك، حافظ على جميع المحادثات داخل تطبيق \"وان فوريفر\". تجنب مشاركة معلومات الاتصال الشخصية، مثل أرقام الهواتف أو عناوين البريد الإلكتروني، مع معارف جدد. يساعد الاحتفاظ بالمحادثات داخل المنصة فريق إدارة التطبيق لدينا على مراقبة التفاعلات والاستجابة بسرعة لأي مشكلات.",
      KnowYourLimits: "اعرف حدودك",
      enjoyYourselfButAlwaysPrioritizeYourSafety:
        "استمتع بوقتك، لكن اجعل سلامتك وراحتك أولوية دائمًا. تجنب المواقف التي قد تفقد فيها السيطرة، وكن دائمًا يقظًا لما يجري حولك.",
      leaveHonestReferences: "اترك مراجع صادقة",
      useTheReferenceSystemToShareYourExperiencesWithOther:
        "استخدم نظام المراجع لمشاركة تجاربك مع أعضاء \"وان فوريفر\" الآخرين. تقديم تعليقات صادقة وواضحة يساعد المجتمع على اتخاذ قرارات مستنيرة ويعزز بيئة أكثر أمانًا.",
      reportSafetyConcerns: "الإبلاغ عن مخاوف السلامة",
      ifYouEncounterAnySafetyIssuesReportThemToOurTrust:
        "إذا واجهت أي مشكلات تتعلق بالسلامة، قم بالإبلاغ عنها لفريق الأمان والثقة لدينا. تساعدنا تقاريرك في الحفاظ على نزاهة \"وان فوريفر\" وحماية الأعضاء في المستقبل.",
      acceptance: "من خلال الالتزام بهذه الإرشادات، يمكننا إنشاء تجربة مجتمعية إيجابية ومثرية للجميع. شكرًا لكونك عضوًا قيمًا في \"وان فوريفر\"!"
    },
  };
  return (
    <>
      <PageBanner />
      <div className={`container pt-5 ${language === "ar" ? "rtl" : ""}`}>
        <div className=" row ">
          <div className="privacy-main-header">
            {text[language].safetyBasics}
          </div>
          <p className="privacy-content">
            {
              text[language]
                .atOneFureverWeBelieveInFosteringAPositiveAndInclusive
            }
          </p>
          <div className="privacy-content">
            {
              text[language]
                .yourSafetyIsOurPriorityPleaseFollowTheseEssentialGuideline
            }
          </div>
          <div className="privacy-main-header">
            {text[language].reviewProfilesAndReferencesCarefully}
          </div>
          <p className="privacy-content">
            {text[language].beforeParticipatingInaPlaytimeOrEventTakeTheTime}
          </p>
          <div className="privacy-sub-title">
            {text[language].trustYourInstincts}
          </div>
          <p className="privacy-content">
            {
              text[language]
                .ifaSituationPersonOrProfileSeemsUnsafeListenToYourGut
            }
          </p>
          <div className="privacy-sub-title">
            {text[language].stayInformedAboutLocalCultureAndSafetyPractices}
          </div>
          <p className="privacy-content">
            {text[language].ifYouAreTravelingTakeTheTimeToResearchCulturalNorms}
          </p>
          <div className="privacy-sub-title">
            {text[language].communicateThroughOneFurever}
          </div>
          <p className="privacy-content">
            {
              text[language]
                .ForYourSafetyKeepAllCommunicationWithinTheOneFureverMobileApp
            }
          </p>
          <div className="privacy-sub-title">
            {text[language].KnowYourLimits}
          </div>
          <p className="privacy-content">
            {text[language].enjoyYourselfButAlwaysPrioritizeYourSafety}
          </p>
          <div className="privacy-sub-title">
            {text[language].leaveHonestReferences}
          </div>
          <p className="privacy-content">
            {
              text[language]
                .useTheReferenceSystemToShareYourExperiencesWithOther
            }
          </p>
          <div className="privacy-sub-title">
            {text[language].reportSafetyConcerns}
          </div>
          <p className="privacy-content">
            {text[language].ifYouEncounterAnySafetyIssuesReportThemToOurTrust}
          </p>
          <p className="privacy-content">
            {
              text[language].acceptance
            }
          </p>
        </div>
      </div>
    </>
  );
};

export default Safety;
